import React, { ReactNode, useRef } from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { useHover } from '@expo/style-utils';

import { Divider, Text } from '.';
import { TOOLTIP_COLOR } from '../constants/colors';

type Offset = {
  top?: number;
  left?: number;
  right?: number;
  bottom?: number;
};
type Props = {
  header?: (ReactNode) | string;
  content?: (ReactNode) | string;
  children: ReactNode;
  offset?: Offset;
  containerStyle?: StyleProp<ViewStyle>;
};
export default function Tooltip(props: Props) {
  let { header, content, children, offset, containerStyle } = props;

  const ref = useRef(null);
  const { isHovered } = useHover(ref);

  let TooltipContent = (
    <View style={[styles.tooltipContainer, containerStyle, offset]}>
      <View style={styles.tooltipHeader}>
        {header &&
          (typeof header === 'string' ? (
            <Text weight="medium" style={styles.tooltipTitle}>
              {header}
            </Text>
          ) : (
            header
          ))}
      </View>
      {header && <Divider style={styles.divider} />}
      <View style={styles.tooltipContent}>
        {content &&
          (typeof content === 'string' ? (
            <Text weight="normal" color={TOOLTIP_COLOR.subtitle}>
              {content}
            </Text>
          ) : (
            content
          ))}
      </View>
    </View>
  );

  return (
    <View ref={ref}>
      {children}
      {isHovered && TooltipContent}
    </View>
  );
}

const styles = StyleSheet.create({
  tooltipContainer: {
    width: 280,
    padding: 12,
    backgroundColor: TOOLTIP_COLOR.background,
    position: 'absolute',
    shadowColor: TOOLTIP_COLOR.shadow,
    shadowOpacity: 0.2,
    shadowRadius: 12,
    shadowOffset: {
      height: 4,
      width: 0,
    },
    zIndex: 2,
  },
  tooltipHeader: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tooltipContent: {
    backgroundColor: 'white',
  },
  tooltipTitle: {
    flex: 1,
  },
  tintColor: {
    width: 8,
    height: 8,
    borderRadius: 8 / 2,
    marginRight: 8,
  },
  divider: {
    marginVertical: 8,
  },
});
